import { render, staticRenderFns } from "./bookingScreen.vue?vue&type=template&id=ec8a4b5c&scoped=true&"
import script from "./bookingScreen.vue?vue&type=script&lang=js&"
export * from "./bookingScreen.vue?vue&type=script&lang=js&"
import style0 from "./bookingScreen.vue?vue&type=style&index=0&id=ec8a4b5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8a4b5c",
  null
  
)

export default component.exports